import { render, staticRenderFns } from "./Diseases.vue?vue&type=template&id=af16269a&scoped=true&"
import script from "./Diseases.vue?vue&type=script&lang=js&"
export * from "./Diseases.vue?vue&type=script&lang=js&"
import style0 from "./Diseases.vue?vue&type=style&index=0&id=af16269a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16269a",
  null
  
)

export default component.exports